import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
  getActionIconButtonSize,
  Icon,
  StyledIconButton,
} from './inline-base-styles';
import { faPencilAlt, faEye } from '@fortawesome/free-solid-svg-icons';
import { LinkButton } from './link-button';
import styled from 'styled-components';

const MarginButton = styled(LinkButton)`
  margin-left: 6px;
`;

const MarginButtonWithoutText = styled(LinkButton)`
  ${StyledIconButton}
`;

export interface EditButtonProps {
  text?: string;
  startIcon?: React.ReactNode;
  withoutText?: boolean;
  disabled?: boolean;
  canEdit?: boolean;
  targetId: string;
  size?: 'large' | 'medium' | 'small';
}

export const EditButtonWithText: React.FC<
  Omit<EditButtonProps, 'withoutText'>
> = ({ text, targetId, canEdit, ...rest }) => {
  const { t } = useTranslation(['translation', 'admin']);
  const location = useLocation();

  return (
    <MarginButton
      variant="contained"
      color="primary"
      size="small"
      to={`${location.pathname}/edit/${targetId}`}
      startIcon={
        <Icon icon={canEdit ? faPencilAlt : faEye} aria-hidden="true" />
      }
      {...rest}
    >
      <span className="d-none d-lg-inline">
        {String(t(text || `global.buttons.${canEdit ? 'edit' : 'show'}`))}
      </span>
    </MarginButton>
  );
};

export const EditButtonWithoutText: React.FC<
  Omit<EditButtonProps, 'text' | 'withoutText'>
> = ({ targetId, canEdit, size = 'small', ...rest }) => {
  const location = useLocation();
  const dimension = getActionIconButtonSize(size);

  return (
    <MarginButtonWithoutText
      variant="contained"
      color="primary"
      size={size}
      to={`${location.pathname}/edit/${targetId}`}
      {...rest}
      style={{
        width: dimension,
        minWidth: dimension,
        maxWidth: dimension,
        height: dimension,
        minHeight: dimension,
        maxHeight: dimension,
        marginBottom: '0',
        padding: '0',
      }}
    >
      <Icon icon={canEdit ? faPencilAlt : faEye} aria-hidden="true" size="sm" />
    </MarginButtonWithoutText>
  );
};
